import { Col, Flex, Row, message } from "antd";
import { useMutation, useQuery } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";
import { createImageCapture } from "../../../lib/api/resources/imageCaptures";
import { ImageCaptureFormCard } from "./components/ImageCaptureFormCard";
import { ImageCaptureAccount } from "@rumble-it/common-lib/types/models/ImageCapture.interface";
import { fetchImageCaptureAccounts } from "@/lib/api/resources/imageCaptureAccounts";

export const ImageCaptureCreate = () => {
  const navigate = useNavigate();

  const { data: accounts, isLoading: isAccountsLoading } = useQuery({
    queryKey: ["imageCaptureAccounts"],
    queryFn: () => fetchImageCaptureAccounts(),
  });

  const accountOptions = Array.isArray(accounts)
    ? accounts.map((acc: ImageCaptureAccount) => ({
        label: acc.title,
        value: acc["@id"],
      }))
    : [];

  const createImageCaptureMutation = useMutation({
    mutationFn: async (data: any) => createImageCapture(data),
    onSuccess: () => {
      navigate("/image-captures");
      message.success("ImageCapture succesvol aangemaakt");
    },
    onError: () => {
      message.error(
        "Er is een fout opgetreden bij het aanmaken van de ImageCapture",
      );
    },
  });

  return (
    <div>
      <Row gutter={[16, 16]}>
        <Col span={12}>
          <Flex vertical gap={16}>
            <ImageCaptureFormCard
              loading={isAccountsLoading}
              accountOptions={accountOptions}
              mutation={createImageCaptureMutation}
            />
          </Flex>
        </Col>
      </Row>
    </div>
  );
};
